var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 121,
    viewBox: "0 0 343 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.401489,
    width: 343,
    height: 120,
    rx: 8,
    fill: "#C6CEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.869 50.8887C159.874 50.2395 160.398 49.7141 161.048 49.709H182.452C183.103 49.709 183.63 50.2377 183.63 50.8887V69.9144C183.626 70.5636 183.101 71.0889 182.452 71.0941H161.048C160.397 71.0935 159.869 70.5655 159.869 69.9144V50.8887ZM181.254 52.0852H162.245V68.718L173.285 57.6761C173.749 57.2124 174.501 57.2124 174.965 57.6761L181.254 63.9776V52.0852ZM164.621 56.8373C164.621 58.1496 165.685 59.2134 166.997 59.2134C168.31 59.2134 169.373 58.1496 169.373 56.8373C169.373 55.525 168.31 54.4612 166.997 54.4612C165.685 54.4612 164.621 55.525 164.621 56.8373Z",
    fill: "#E8EBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgframe);
export default __webpack_public_path__ + "static/media/imgframe.ba6737048dfcc6095ebdf9b27a79e766.svg";
export { ForwardRef as ReactComponent };